import {React, useEffect} from 'react'
import logo from './img/edaplogo.png'
import './Nav.css'

function Nav() {
    useEffect(() => {
        const handleScroll = () => {
          const navbar = document.querySelector('.navbarS');
          const logo = document.querySelector('.logo');
          const logox = document.querySelector('.logo-text');

          if (window.scrollY > 10) {
            navbar.classList.add('scrolled');
            logo.classList.add('hide-logo');
            logox.classList.add('hide-logo');
          } else {
            navbar.classList.remove('scrolled');
            logo.classList.remove('hide-logo');
            logox.classList.remove('hide-logo');
          }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

        function scrollToTop(event) {
          window.scrollTo({
              top: 0,
              behavior: 'smooth'
          });
          event.preventDefault();
          document.getElementById("scrollableDiv").scrollTo({
              top: 0,
              behavior: 'smooth'
          });
      }

    return (
      <div class="ISTAM">
          <div className="top-nav">
            <div className='logo-text'>
              <a href="adminISTAM">
                <img src={logo} className="logo" style={{ width: '5%', position: 'fixed', top: 0, zIndex: 1}} />
              </a>
              <a href="admin" id='log-txt' className="logtex">
                <strong>Institut Supérieur des techniques avancées et de Management (ISTAM)</strong>
              </a>
            </div>
          <nav className="navbarS">
            <ul className="nav-links">
              <li><a href="#home"><strong>CONTACT</strong></a></li>
              <li><a href="option"><strong>LOGIN</strong></a></li>
            </ul>
          </nav>
          <br/>
          <br/>
        </div>
      </div>
    )
}

export default Nav;